import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Opens checkout leftover dialog from navigation state and clears state on close.
 */
export function useCheckoutLeftoversNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);

  const checkoutLeftovers = location.state?.checkoutLeftovers;

  useEffect(() => {
    if (Array.isArray(checkoutLeftovers) && checkoutLeftovers.length > 0) {
      setRows(checkoutLeftovers);
      setOpen(true);
    }
  }, [location.key, location.pathname, checkoutLeftovers]);

  const closeLeftovers = useCallback(() => {
    setOpen(false);
    const state = location.state || {};
    if (!state.checkoutLeftovers) return;
    const { checkoutLeftovers: _removed, ...rest } = state;
    navigate(location.pathname, {
      replace: true,
      state: Object.keys(rest).length ? rest : undefined,
    });
  }, [location.pathname, location.state, navigate]);

  return { leftoversOpen: open, leftoversRows: rows, closeLeftovers };
}
